import { useState, useEffect } from 'react';
import './AddModal.css';

function EditProxyModal({ proxy, isOpen, onClose, onSave }) {
  const [host, setHost] = useState('');
  const [port, setPort] = useState('');
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (proxy) {
      setHost(proxy.host || '');
      setPort(proxy.port || '');
      setLogin(proxy.login || '');
      setPassword(proxy.password || '');
      setError(null);
    }
  }, [proxy, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    if (!host || !port) {
      setError('Host e Porta são obrigatórios.');
      return;
    }
    onSave({
      ...proxy,
      host,
      port,
      login,
      password
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Editar Proxy</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Host</label>
            <input type="text" value={host} onChange={e => setHost(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Porta</label>
            <input type="number" value={port} onChange={e => setPort(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Login</label>
            <input type="text" value={login} onChange={e => setLogin(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Senha</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditProxyModal;
